/**
 * Clear client-side caches after logout so sensitive authenticated views
 * cannot be restored from the service worker / Cache Storage when offline.
 * Does not unregister the SW (PWA update channel stays intact).
 */
export async function clearAuthClientState(): Promise<void> {
  try {
    sessionStorage.clear();
  } catch {
    // ignore
  }

  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (!key) continue;
      // Preserve active publication preference only; drop any auth-adjacent keys.
      if (key.startsWith('spox.avatar.') || key.startsWith('spox.auth.')) {
        keysToRemove.push(key);
      }
    }
    for (const key of keysToRemove) localStorage.removeItem(key);
  } catch {
    // ignore
  }

  if (typeof caches !== 'undefined') {
    try {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    } catch {
      // ignore
    }
  }
}
